import React, { useEffect } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
// import { modal } from 'style/config';
import Modal from 'components/Modal/Modal';
import { useSelector } from 'react-redux';
import { shipToAccessPointModalSelector } from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipToAccessPoint/ShipToAccessPointModal/shipToAccessPointModalSelector';
import FrictionlessCheckoutBindings from 'analytics/bindingMethods/pages/FrictionlessCheckout/FrictionlessCheckoutBindings';

const ShipToAccessPointModal = ({ children, onDismiss, isOpen, deliverToEditMode }) => {
    const { shipToAccessPointModalTitle } = useSelector(shipToAccessPointModalSelector);

    useEffect(() => {
        if (isOpen) {
            FrictionlessCheckoutBindings.addPickupPersonModalAnalytics();
        }
    }, [isOpen]);

    const dismissHandler = () => {
        onDismiss(false, deliverToEditMode);
    };

    return (
        <Modal
            isOpen={isOpen}
            showDismiss={true}
            onDismiss={dismissHandler}
            width={0}
            isDrawer={true}
        >
            <Modal.Header>
                <Modal.Title>{shipToAccessPointModalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body
                paddingTop={0}
                paddingBottom={5}
            >
                {children}
            </Modal.Body>
        </Modal>
    );
};

export default wrapFunctionalComponent(ShipToAccessPointModal, 'ShipToAccessPointModal');
